// @ts-strict-ignore
import { FormatterMiddleware, FormatterMiddlewareFormatParams, TolgeePlugin } from '@tolgee/ngx';
import engbDashboard from '../../../assets/i18n/dashboard/en-GB.json';
import engb from '../../../assets/i18n/en-GB.json';

export type TranslationsType = typeof engb;
export type TranslationsTypeDashboard = typeof engbDashboard;

type TranslationTree<T extends object, Prefix extends string> = {
  [K in keyof T as Uppercase<K & string>]: T[K] extends object
    ? TranslationTree<T[K], `${Prefix}${K & string}.`>
    : `${Prefix}${K & string}`;
};

type Translations = TranslationTree<TranslationsType, ''>;
type TranslationsDashboard = TranslationTree<TranslationsTypeDashboard, ''>;

const replaceStringsWithPath = <T>(data: T, prefix: string = ''): Translations | TranslationsDashboard => {
  return Object.entries(data).reduce((result, [k, value]) => {
    const key = k.toUpperCase();
    const fullPath = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'object') {
      result[key] = replaceStringsWithPath(value, fullPath);
    } else {
      result[key] = fullPath.toLowerCase();
    }
    return result;
  }, {} as any);
};

export const UI_STRINGS = <Translations>replaceStringsWithPath<TranslationsType>(engb);
export const DASHBOARD_STRINGS = <TranslationsDashboard>(
  replaceStringsWithPath<TranslationsTypeDashboard>(engbDashboard)
);

const createLegacyFormatter = (): FormatterMiddleware => {
  const regex = /\{[^}]*\}/g;

  const format = (props: FormatterMiddlewareFormatParams) => {
    if (!props.params?.legacy || (JSON.parse(props.params?.legacy) as any[]).length === 0) {
      return props.translation;
    }

    const legacyParams: (string | number)[] = JSON.parse(props.params?.legacy);

    const matches: string[] = props.translation.match(regex) ?? [];

    matches.forEach((match, i) => {
      const key = match.replace('{', '').replace('}', '');
      props.params[key] = legacyParams[i].toString();
    });

    delete props.params.legacy;

    return props.translation;
  };
  return Object.freeze({ format });
};

export const FormatLegacy = (): TolgeePlugin => (tolgee, tools) => {
  tools.addFormatter(createLegacyFormatter());

  return tolgee;
};
